import Image from 'next/image'

import logoIcon from '@/assets/logo-icon.png'

const Logo = () => {
  return (
    <span className="flex h-[5.6rem] w-[9.2rem] items-center justify-center md:h-[6.3rem] md:w-[10.6rem]">
      <Image
        src={logoIcon}
        width={181}
        height={94}
        alt="Olio Farchioni"
        className="h-[4rem] w-[7.6rem] md:h-[4.7rem] md:w-[9rem]"
      />
    </span>
  )
}

export default Logo
